var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.273 1-.166.44-.545 1.407-.361.908c-2.747 6.802-4.883 10.03-7.156 10.03a4.137 4.137 0 0 1-3.087-1.265l-.29-.263c-.721-.666-1.025-.83-1.72-.83-.362 0-1.01.461-1.828 1.545a27.494 27.494 0 0 0-2.784 4.964l-.092.205h9.746l-1.214 2.525h-9.1V31H7V1h21.273zm-3.792 2.52H9.677v9.996c1.774-3.078 3.46-4.622 5.274-4.622a4.406 4.406 0 0 1 3.29 1.32l.298.272c.674.622.933.765 1.51.765.632.002 2.317-2.674 4.433-7.73z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront);
export default __webpack_public_path__ + "static/media/FRONT.0991bc2ca16887229c45ec6de38fc68a.svg";
export { ForwardRef as ReactComponent };